import { Pipe, PipeTransform } from '@angular/core';

/**
 * Truncates a long string to the requested length and appends an ellipsis.
 *
 * Usage: `{{ longText | truncate:30 }}` -> will cut to 30 chars + `…` when needed.
 * - If `length` is not provided defaults to `50`.
 * - If input is falsy returns an empty string.
 */
@Pipe({ name: 'truncate', pure: true })
export class TruncatePipe implements PipeTransform {
  transform(value: string | null | undefined, length = 50, ellipsis = '…'): string {
    if (!value) return '';
    const max = Math.max(0, Math.floor(length));
    if (value.length <= max) return value;
    return value.slice(0, max) + ellipsis;
  }
}
